import { render, staticRenderFns } from "./SitesPage.vue?vue&type=template&id=22e79780&scoped=true"
import script from "./SitesPage.vue?vue&type=script&lang=js"
export * from "./SitesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e79780",
  null
  
)

export default component.exports